import React from 'react'
import { DeckMappDialog } from '../../../DeckMappDialog'
import { Typography, Button } from '@mui/material'

export const ErrorDialog = React.memo(
  function ErrorDialog_({ onOkPressed, error }) {
    if (!error) {
      return null
    }
    return (
      <DeckMappDialog
        open
        title={'Wear App - Eror'}
        Actions={
          <>
            <Button variant="outlined" color="secondary" onClick={onOkPressed}>
              Ok
            </Button>
          </>
        }>
        <Typography>{error}</Typography>
      </DeckMappDialog>
    )
  },
  (prev, next) => prev.error === next.error
)
